import script from "./chatToRole.vue?vue&type=script&setup=true&lang=js"
export * from "./chatToRole.vue?vue&type=script&setup=true&lang=js"

import "./chatToRole.vue?vue&type=style&index=0&id=c43b7f28&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c43b7f28"]])

export default __exports__